import _typeof from "D:\\repos-foodeo\\foodeo-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/typeof";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import { __awaiter, __generator } from "tslib";
import { networkErrors, toastPresets } from '@/constants'; // TODO:Agregar todos los modelos para ser inyectados.----Done----
// TODO:Arreglar los permisos, Hacer que el modelo pida sus permisos al loggear.
// TODO: Agregar Lodash para cloneDeep
// TODO: Arreglar algoritmo de mapeo a recursivo n-prof
// tslint:disable-next-line:max-line-length

var BaseModel =
/** @class */
function () {
  function BaseModel(model, service) {
    this.modelName = '';
    this.request = 'JSON';
    this.uniqueField = 'id';
    this.service = service;
    this.model = JSON.parse(JSON.stringify(model));
    this.initializeModel(model);
  }
  /**
   * Method to determine if insert or update based on uniqueField.
   * Removes empty fields
   */


  BaseModel.prototype.beforeSave = function () {
    var _this = this; // Call specific model validations


    var check = this.check(); // Delete empty fields

    Object.keys(this.model).forEach(function (key) {
      if (Array.isArray(_this.model[key]) && !_this.model[key].length || _this.model[key] === undefined || _this.model[key] === null || _this.model[key] === '') {
        delete _this.model[key];
      }
    }); // Check Model validations and return which method to execute insert/update or return errors

    if (check[0]) {
      if (this.model.hasOwnProperty(this.uniqueField)) {
        return [true, 'update'];
      }

      return [true, 'create'];
    }

    return [false, check[1]];
  };

  BaseModel.prototype.list = function (query, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = null;
    }

    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getAll(query)];

          case 1:
            request = _a.sent();

            if (request.complete) {
              return [2
              /*return*/
              , this.handleSuccess({
                data: request.data.results,
                total: request.data.total
              }, request.message, null, toastConfig)];
            } else {
              this.handleError(request, toast, toastConfig);
              return [2
              /*return*/
              , {
                data: [],
                total: 0
              }];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseModel.prototype.get = function (query, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getBy(query)];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, toast, toastConfig)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseModel.prototype.save = function (toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var modelMapped, _a, before, method, data;

      return __generator(this, function (_b) {
        modelMapped = this.mapModel();
        _a = this.beforeSave(), before = _a[0], method = _a[1];
        data = this.createRequestObject(modelMapped);

        if (before) {
          return [2
          /*return*/
          , this[method](data, toast, toastConfig)];
        } else if (before && _typeof(method) === 'object') {
          // method.forEach((error) => {
          //     },
          // );
          return [2
          /*return*/
          , false];
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  BaseModel.prototype.create = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var query, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            query = {
              query: data,
              method: 'POST'
            };
            return [4
            /*yield*/
            , this.service.insert(query)];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, toast, toastConfig)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseModel.prototype.update = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var fields, query, response;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            fields = this.request === 'JSON' ? JSON.parse(data) : (_a = {}, _a[this.uniqueField] = data.get(this.uniqueField), _a);
            query = {
              query: data,
              method: 'PUT',
              id: fields[this.uniqueField]
            };
            return [4
            /*yield*/
            , this.service.update(query)];

          case 1:
            response = _b.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, toast, toastConfig)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseModel.prototype.delete = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var query, response, query, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!Array.isArray(data)) return [3
            /*break*/
            , 2];
            query = {
              query: {
                pk__in: data
              },
              method: 'POST',
              url: 'delete_all'
            };
            return [4
            /*yield*/
            , this.service.request(query)];

          case 1:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, toast, toastConfig)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [3
            /*break*/
            , 4];

          case 2:
            query = {
              id: data,
              method: 'DELETE'
            };
            return [4
            /*yield*/
            , this.service.deleteBy(query)];

          case 3:
            response = _a.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, toast, toastConfig)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            _a.label = 4;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseModel.prototype.restore = function (data, toast, toastConfig) {
    if (toast === void 0) {
      toast = null;
    }

    if (toastConfig === void 0) {
      toastConfig = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      var query, response;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            query = {
              query: (_a = {}, _a[this.uniqueField] = data, _a),
              method: 'GET'
            };
            return [4
            /*yield*/
            , this.service.restoreBy(query)];

          case 1:
            response = _b.sent();

            if (response.complete) {
              return [2
              /*return*/
              , this.handleSuccess(response.data, response.message, toast, toastConfig)];
            } else {
              this.handleError(response, toast, toastConfig);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  BaseModel.prototype.handleError = function (e, toast, toastConfig) {
    if (toastConfig === void 0) {
      toastConfig = toastPresets.error;
    }

    switch (e.message) {
      case networkErrors.server:
        if (toast) {
          toast.error('Error en el servidor, pruebe mas tarde', toastConfig);
        }

        return;

      case networkErrors.validation:
        var finalTextArray_1 = [];
        Object.keys(e.response.message).forEach(function (errorKey) {
          var reduce = e.response.message[errorKey].reduce(function (t, elem) {
            return t + "\n" + ("" + elem);
          });
          finalTextArray_1.push(reduce);
        });

        if (toast) {
          toast.error(finalTextArray_1.join('\n'), toastConfig);
        }

        return;

      case networkErrors.perms:
        return Object.keys(e.response).forEach(function (errorKey) {
          var reduce = e.response[errorKey].reduce(function (t, elem) {
            return t + "\n" + ("" + elem);
          });

          if (toast) {
            toast.error(reduce, toastConfig);
          }
        });

      case networkErrors.auth:
        return;

      case networkErrors.notFound:
        return;
    }
  };

  BaseModel.prototype.handleSuccess = function (response, message, toast, toastConfig) {
    if (toastConfig === void 0) {
      toastConfig = toastPresets.success;
    }

    if (toast) {
      toast.success(message, toastConfig);
    }

    return response || true;
  };

  BaseModel.prototype.check = function () {
    return [true, []];
  };

  BaseModel.prototype.clean = function () {
    return this.model;
  };

  BaseModel.prototype.mapModel = function () {
    var _this = this;

    Object.keys(this).forEach(function (key) {
      if (key === _this.uniqueField) {
        // @ts-ignore
        _this.model[_this.uniqueField] = _this[key];
      }

      if (_this.model.hasOwnProperty(key)) {
        // @ts-ignore
        _this.model[key] = _this[key];
      }
    });
    return this.model;
  };

  BaseModel.prototype.mapRow = function (row, filters) {
    var _this = this;

    if (filters === void 0) {
      filters = {};
    }

    Object.keys(row).forEach(function (key) {
      _this[key] = row[key];
    });
  };

  BaseModel.prototype.createRequestObject = function (mappedDTO, requestType) {
    if (requestType === void 0) {
      requestType = this.request;
    }

    var data;

    if (requestType === 'JSON') {
      data = JSON.stringify(mappedDTO);
    } else if (requestType === 'FormData') {
      data = new FormData();
      Object.keys(mappedDTO).forEach(function (key) {
        if (_typeof(mappedDTO[key]) === 'object' && !(mappedDTO[key] instanceof File)) {
          return data.append(key, JSON.stringify(mappedDTO[key]));
        }

        data.append(key, mappedDTO[key]);
      });
    }

    return data;
  };

  BaseModel.prototype.initializeModel = function (model) {
    var _this = this;

    var mod = JSON.parse(JSON.stringify(model));
    Object.keys(model).forEach(function (key) {
      _this[key] = mod[key];
    });
  };

  return BaseModel;
}();

export { BaseModel };